module.exports = __webpack_public_path__ + "static/media/profile.62891fe9.jpg";